import { TextMatchTransformer } from '@lexical/markdown';
import { $createTextNode, LexicalNode } from 'lexical';
import {
  $createInlineSuggestionNode,
  $isAcceptedInlineSuggestion,
  $isInlineSuggestionNode,
  $isRejectedInlineSuggestion,
} from '../../nodes/InlineSuggestionNode';

export const INLINE_SUGGESTION: TextMatchTransformer = {
  type: 'text-match',
  dependencies: [],

  regExp: /<inline-suggestion>(.*?)<\/inline-suggestion>/,
  importRegExp: /<inline-suggestion>(.*?)<\/inline-suggestion>/,
  export: (node: LexicalNode, traverseChildren) => {
    if (!$isInlineSuggestionNode(node)) {
      return null;
    }

    if ($isRejectedInlineSuggestion(node)) {
      return '';
    }

    const output: string[] = [];
    if (!$isAcceptedInlineSuggestion(node)) {
      output.push('<inline-suggestion>');
    }
    output.push(traverseChildren(node));
    if (!$isAcceptedInlineSuggestion(node)) {
      output.push('</inline-suggestion>');
    }
    return output.join('');
  },

  replace: (node, match) => {
    const suggestion = $createInlineSuggestionNode();
    suggestion.append($createTextNode(match[1]));
    node.replace(suggestion);
    suggestion.selectNext();
  },
};
